import { Component, Input, EventEmitter, Output, AfterViewInit } from '@angular/core';
import bulmaCalendar from 'node_modules/bulma-calendar/dist/js/bulma-calendar.min.js';
import { AuthFactoryService } from 'src/app/auth/authFactory.service';

@Component({
  selector: 'app-date',
  templateUrl: './date-range.component.html'
})
export class DateRangeComponent implements AfterViewInit {
  @Input() id: string;
  @Input() error: boolean;
  @Input() disabled: boolean;
  @Input() label: string;
  @Input() errorMessage: string;
  @Input() submitted: boolean;
  @Input() date: string;
  @Input() isException: boolean;
  @Input() maxDate: Date = new Date(8640000000000000);
  @Input() minDate: Date = this.getToday();
  @Input() clearData: boolean = false;

  @Output() sendDate = new EventEmitter<Date>();

  calendars: any;
  selectedDate: Date = this.getToday();

  options = {
    dateFormat: 'dd/MM/yyyy',
    isRange: false,
    displayMode: 'dialog',
    showHeader: true,
    lang: 'es',
    color: 'link',
    type: 'date',
    showButtons: false,
    showFooter: false,
    closeOnSelect: true,
    startDate: this.getToday(),
    date: this.getToday(),
    enableYearSwitch: true,
    displayYearsCount: 6,
    maxDate: null,
    minDate: null
  };

  constructor(private authFactoryService: AuthFactoryService) {}

  ngAfterViewInit() {
    this.options.maxDate = this.maxDate;
    this.options.minDate = this.minDate;
    if (new Date().getFullYear() - this.minDate.getFullYear() > 20) {
      this.options.displayYearsCount = 11;
    }
    this.authFactoryService.getLang().subscribe((lang) => (this.options.lang = lang));
    if (this.date) {
      this.selectedDate = new Date(this.date);
      this.options.date = this.selectedDate;
      this.options.startDate = this.selectedDate;
    }

    this.calendars = bulmaCalendar.attach('#' + this.id, this.options);
    this.calendars.forEach((calendar) => {
      calendar.date = this.date;
      this.clearData ? calendar.clear() : false;
      calendar.on('select', (event) => {
        this.selectedDate = event.data.date.start;
        this.sendDate.emit(this.selectedDate);
      });
    });
  }

  isExceptionValidator() {
    /* Use this function --> isExceptionValidator() <--
    when will be necessary restrict date on calendar if isException */
    if (this.isException) {
      this.options.maxDate = this.addDays(7, new Date(this.selectedDate));
      this.options.minDate = this.addDays(-7, new Date(this.selectedDate));
    }
  }

  getToday(): Date {
    const now = new Date();
    return new Date(now.getFullYear(), now.getMonth(), now.getDate());
  }

  addDays(numOfDays: number, date: Date) {
    date.setDate(date.getDate() + numOfDays);

    return date;
  }
}
